import { render, staticRenderFns } from "./VendorLabors.vue?vue&type=template&id=1b9d6465&"
import script from "./VendorLabors.vue?vue&type=script&lang=js&"
export * from "./VendorLabors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports